import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { isNil } from 'lodash';
import { useCookies } from 'react-cookie';
import { 
    Flex, Input, Button, ButtonGroup, Text, InputGroup, InputRightElement, InputRightAddon, Icon, IconButton,
    Stack, HStack, Image, Wrap, WrapItem, Center, Badge,
    Table, Thead, Tbody, Tfoot, Tr, Th, Td, TableCaption, TableContainer, useDisclosure, useToast
} from '@chakra-ui/react';
import ReactPaginate from 'react-paginate';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/ReactToastify.css'
import { MdAddCircleOutline, MdSearch, MdEdit, MdDeleteForever, MdRestore, MdBlock } from 'react-icons/md';
import { BsArrowLeftCircle, BsArrowRightCircle } from 'react-icons/bs';

import axios from 'axios';
import moment from 'moment';
import { FormattedDate, FormattedTime } from 'react-intl';

import { SUCCESS_STATUS, FAILED_STATUS } from '../../../constants';
import "../../../styles/index.scss";

import { 
    apiLoadListCompany, apiLoadACompany, apiCreateNewCompany, apiUpdateACompany, apiDeleteACompany
} from '../../../redux/apis';
import { clearACompanyDetail, clearCompanyActionStatus } from '../../../redux/actions';
import { getCompanyList, getACompany, getCompanyActionStatus, getCompanyActionMsg, getCompanyError } from '../../../redux/selectors';
import { displayConfirmAlert, displayConfirmChoiceAlert } from '../../utils';

import NoDataPage from '../../../components/NoData';
import AddEditCompanyModal from '../Modals/AddEditCompanyModal';

// function usePrevious(value) {
//     const ref = useRef();
//     useEffect(() => {
//         ref.current = value;
//     });
//     return ref.current;
// }

function Companies({ 
    companyList, companyDetail, actionStatus, actionMsg, error, clearACompanyDetail, clearCompanyActionStatus,
    apiLoadListCompany, apiLoadACompany, apiCreateNewCompany, apiUpdateACompany, apiDeleteACompany
}) {
    const [ cookies, setCookie, removeCookie ] = useCookies(["loginCookie"]);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const initialRef = useRef(null);
    
    const [ searchText, setSearchText ] = useState("");
    const [ isSearching, setIsSearching ] = useState(false);

    const mounted = useRef();
    //const prevCompanyDetail = usePrevious(companyDetail);

    useEffect(() => {
        if(!mounted.current) {
            apiLoadListCompany({ all: true });
            mounted.current = true;
        } else {
            if(actionStatus === SUCCESS_STATUS) {
                if(isOpen) {
                    onClose();
                }
                toast.success(actionMsg, {
                    position: "bottom-right"
                });
                clearCompanyActionStatus();
            } 
            else if(actionStatus === FAILED_STATUS) {         
                toast.error(error, {
                    position: "bottom-right"
                });
                clearCompanyActionStatus();
            }
        }
    });

    const handleAddNewCompany = () => {
        clearACompanyDetail();
        onOpen();
    }

    const handleUpdateACompany = (company_id) => {
        apiLoadACompany({ id: company_id });
    }

    const handleBlockACompany = (company_id) => {
        displayConfirmChoiceAlert(`Bạn có muốn cấm phòng khám này không?`, () => {
            apiUpdateACompany({ id: company_id, payload: { is_active: false } });
        });
        // confirmAlert({
        //     customUI: ({ onClose }) => {
        //         return (
        //             <div className='custom-ui'>
        //                 <h1>
        //                     Xác nhận <br />Bạn có muốn cấm phòng khám này không?
        //                 </h1>
        //                 <div>
        //                     <button onClick={onClose}>Huỷ</button>
        //                     <button
        //                         onClick={() => {
        //                             apiUpdateACompany({ id: company_id, payload: { is_active: false } });
        //                             onClose();
        //                         }}
        //                         className='yes'
        //                     >
        //                         Đồng Ý
        //                     </button>
        //                 </div>
        //             </div>
        //         )
        //     },
        //     closeOnClickOutside: false
        // })
    }

    const handleRestoreACompany = async(company_id) => {
        displayConfirmChoiceAlert(`Bạn có muốn khôi phục phòng khám này không?`, () => {
            apiUpdateACompany({ id: company_id, payload: { is_active: true } });
        });

        // try
        // {
        //     let res = await axios.put(`${process.env.REACT_APP_API_ENDPOINT_URL}/companies/${company_id}`, {
        //         is_active: true
        //     }, {
        //         auth: {
        //             username: process.env.REACT_APP_BASIC_AUTH_USERNAME,
        //             password: process.env.REACT_APP_BASIC_AUTH_PASSWORD
        //         }
        //     });

        //     if(res.data?.status === 200) {
        //         displayConfirmAlert("Bạn đã khôi phục tài khoản thành công!")
        //     }
        // }
        // catch(error) {
        //     if(error?.code) {
        //         toast.error(`${ERROR_CODES[error?.code]} (${error?.code})`, {
        //             position: "bottom-right"
        //         });
        //     }
        // }
    }

    const handleDeleteACompany = (company_id) => {
        displayConfirmChoiceAlert(`Bạn có muốn xoá phòng khám này không?`, () => {
            apiDeleteACompany({ id: company_id });
        });

        // confirmAlert({
        //     customUI: ({ onClose }) => {
        //         return (
        //             <div className='custom-ui'>
        //                 <h1>
        //                     Xác nhận <br />Bạn có muốn xoá phòng khám này không?
        //                 </h1>
        //                 <div>
        //                     <button onClick={onClose}>Huỷ</button>
        //                     <button
        //                         onClick={() => {
        //                             apiDeleteACompany({ id: company_id });
        //                             onClose();
        //                         }}
        //                         className='yes'
        //                     >
        //                         Đồng Ý
        //                     </button>
        //                 </div>
        //             </div>
        //         )
        //     },
        //     closeOnClickOutside: false
        // })
    }

    return (
        <React.Fragment>
            <Flex flexDirection={{ base: "column", md: "row", lg: "row" }} borderBottomWidth="2px" px={4} py={2} gap={2} justify="space-between">
                {
                    (cookies?.loginCookie?.data?.roles === 'super_admin') &&
                    <Button colorScheme='orange' onClick={handleAddNewCompany}>
                        <Icon boxSize={6} as={MdAddCircleOutline} marginRight="8px"/>   
                        <Text fontSize="14px" fontWeight="400">TẠO MỚI</Text>
                    </Button>
                }

                <InputGroup width={{base: "100%", md: "40%", lg: "40%"}} marginRight={12}>
                    <Input placeholder='Tìm kiếm ...' onChange={(evt) => setSearchText(evt.currentTarget.value)} onKeyUp={(evt) => {
                        if(evt.key === "Enter") {
                            setIsSearching(true);
                            apiLoadListCompany({ searchText });
                            setTimeout(() => {
                                setIsSearching(false);
                            }, 500);
                        }
                    }}/>
                    <InputRightAddon p={0}>
                        <Button colorScheme='blue' 
                            isLoading={isSearching}
                            loadingText="Đang tìm kiếm"
                            onClick={() => {
                                setIsSearching(true);
                                apiLoadListCompany({ searchText });
                                setTimeout(() => {
                                    setIsSearching(false);
                                }, 500);
                            }
                        }>
                            Tìm kiếm
                        </Button>
                    </InputRightAddon>
                </InputGroup>
            </Flex>
            
            {
                companyList && companyList.length > 0 &&
                <PaginatedItems items={companyList} itemsPerPage={10} onOpen={onOpen} isSuperAdmin={cookies?.loginCookie?.data?.roles === 'super_admin'}
                    handleUpdateACompany={handleUpdateACompany} handleDeleteACompany={handleDeleteACompany} 
                    handleBlockACompany={handleBlockACompany} handleRestoreACompany={handleRestoreACompany}
                />
            }
            {
                !(companyList && companyList.length > 0) &&
                <NoDataPage  text="Hiện tại không có dữ liệu"/>
            }
            {/* {
                isSearching &&
                <Center>
                    <CircularProgress position="fixed" top="20vh" isIndeterminate size="200px" zIndex={9999}>
                        <CircularProgressLabel fontSize="24px" fontWeight="700" color="#2196f3">Đang tải ...</CircularProgressLabel>
                    </CircularProgress>
                </Center>
            }        */}
            {
                isOpen &&
                <AddEditCompanyModal 
                    initialRef={initialRef} isOpen={isOpen} onClose={onClose} companyList={companyList} companyDetail={companyDetail} actionStatus={actionStatus}
                    apiCreateNewCompany={apiCreateNewCompany} apiUpdateACompany={apiUpdateACompany}
                />
            }
            <ToastContainer />
        </React.Fragment>
    )
}

function PaginatedItems({ items, itemsPerPage, onOpen, isSuperAdmin, handleUpdateACompany, handleDeleteACompany, handleBlockACompany, handleRestoreACompany }) {
    const [itemOffset, setItemOffset] = useState(0);
    const endOffset = itemOffset + itemsPerPage;
    const currentItems = items.slice(itemOffset, endOffset);
    const pageCount = Math.ceil(items.length / itemsPerPage);

    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % items.length;
        setItemOffset(newOffset);
    } 

    return (
        <>
           <TableContainer width="100%" px="20px" py="5px">
                <Table variant="simple" size="sm">
                    <Thead>
                        <Tr bg="#EAF0F0">
                            <Th>STT</Th>  
                            <Th>PHÒNG KHÁM</Th> 
                            <Th>LOGO</Th>
                            <Th>NGÀY HẾT HẠN</Th>   
                            <Th>NGƯỜI ĐẠI DIỆN</Th>
                            <Th>ĐỊA CHỈ</Th>
                            <Th>EMAIL</Th>
                            <Th>SỐ ĐIỆN THOẠI</Th>
                            <Th>THỜI GIAN TẠO</Th>
                            <Th>THỜI GIAN SỬA</Th>
                            <Th isNumeric></Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {
                            currentItems && currentItems.map((item, idx) => {
                                let badgeActiveExpired = null;
                                if(item.active_expired) {
                                    let momentActiveExpired = moment(item.active_expired);
                                    let momentCurrentDate = moment(new Date());
                                    let diffDays = momentActiveExpired.diff(momentCurrentDate, "days");        
                                    if(diffDays < 0) {
                                        badgeActiveExpired = <Badge variant="solid" colorScheme='red'>HẾT HẠN</Badge>
                                    }
                                } else {
                                    badgeActiveExpired = <Badge variant="solid" colorScheme='red'>HẾT HẠN</Badge>
                                }

                                return (
                                    <Tr key={item.id} style={{ textDecoration: ((item.is_active === false && isNil(item.bank_transfer_context)) ? "line-through" : "") }}>
                                        <Td>
                                            <Text fontWeight="600">{itemOffset + idx + 1}</Text>
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600">{item.name} {badgeActiveExpired}</Text>
                                            {
                                                item.mainCompanyDetail && item.mainCompanyDetail.name &&
                                                <Text>({item.mainCompanyDetail && item.mainCompanyDetail.name})</Text>
                                            }
                                        </Td>
                                        <Td>
                                            {
                                                item.logo_url &&
                                                <Image alt="company_image" src={`${process.env.REACT_APP_UPLOADS_ENDPOINT_URL}/companies/${item.logo_url}`} width="50px" height="50px"/>
                                            }
                                        </Td>
                                        <Td>
                                            <Badge>{item.register_type}</Badge>
                                            {
                                                item.active_expired &&
                                                <Text fontWeight="600" color="red.600">
                                                    <FormattedDate value={item.active_expired} />
                                                </Text>
                                            }
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600">{item.owner}</Text>
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600">{item.address}</Text>
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600">{item.email}</Text>
                                        </Td>
                                        <Td isNumeric>
                                            <Text fontWeight="600">{item.phone}</Text>
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600">
                                                <FormattedDate value={item.created_at} /> <FormattedTime value={item.created_at} />
                                            </Text>
                                        </Td>
                                        <Td>
                                            {
                                                item.updated_at &&
                                                <Text fontWeight="600">
                                                    <FormattedDate value={item.updated_at} /> <FormattedTime value={item.updated_at} />
                                                </Text>
                                            }
                                        </Td>
                                        <Td isNumeric>
                                            <Flex direction="row" justifyContent="flex-end" alignContent="center" gap={4}>
                                                <IconButton
                                                    colorScheme='blackAlpha'
                                                    title='Sửa'
                                                    icon={<MdEdit />}
                                                    onClick={() => {
                                                            onOpen();
                                                            handleUpdateACompany(item.id);
                                                        }
                                                    }
                                                />
                                                {
                                                    (isSuperAdmin == true) &&
                                                    <React.Fragment>
                                                        {
                                                            (item.is_active === false) &&
                                                            <IconButton
                                                                colorScheme='blue'
                                                                title='Khôi phục'
                                                                icon={<MdRestore />}
                                                                onClick={() => handleRestoreACompany(item.id)}
                                                            />
                                                        }
                                                        {
                                                            (item.is_active === true) &&
                                                            <IconButton
                                                                colorScheme='orange'
                                                                title='Cấm công ty'
                                                                icon={<MdBlock />}
                                                                onClick={() => handleBlockACompany(item.id)}
                                                            />
                                                        }
                                                        <IconButton
                                                            colorScheme='red'
                                                            title='Xoá'
                                                            icon={<MdDeleteForever />}
                                                            onClick={() => handleDeleteACompany(item.id)}
                                                        />
                                                    </React.Fragment>
                                                }
                                            </Flex>
                                        </Td>
                                    </Tr>
                                )
                            })
                        }
                    </Tbody>
                </Table>
            </TableContainer>

            {/* <HStack my="5px"> */}
                <ReactPaginate 
                    breakLabel="..."
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={2}
                    pageCount={pageCount}
                    previousLabel={
                        <Center>
                            <Icon boxSize={8} as={BsArrowLeftCircle} />
                        </Center>
                    }
                    nextLabel={
                        <Center>
                            <Icon boxSize={8} as={BsArrowRightCircle} />
                        </Center>
                    }
                    renderOnZeroPageCount={null}
                    containerClassName='pagination'
                    pageClassName='page-item'
                    activeClassName='active'
                    previousClassName='previous-item'
                    nextClassName='next-item'
                />
            {/* </HStack> */}
        </>
    )
}

const mapStateToProps = (state) => {
    const companyList           =   getCompanyList(state);
    const companyDetail         =   getACompany(state);
    const actionStatus          =   getCompanyActionStatus(state);
    const actionMsg             =   getCompanyActionMsg(state);
    const error                 =   getCompanyError(state);

    return { companyList, companyDetail, actionStatus, actionMsg, error };
}

const mapDispatchToProps = (dispatch) => ({
    apiLoadListCompany:        payload => dispatch(apiLoadListCompany(payload)),
    apiLoadACompany:           payload => dispatch(apiLoadACompany(payload)),
    apiCreateNewCompany:       payload => dispatch(apiCreateNewCompany(payload)),
    apiUpdateACompany:         payload => dispatch(apiUpdateACompany(payload)),
    apiDeleteACompany:         payload => dispatch(apiDeleteACompany(payload)),

    clearACompanyDetail:       payload => dispatch(clearACompanyDetail(payload)),
    clearCompanyActionStatus:  payload => dispatch(clearCompanyActionStatus(payload)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Companies);